<template>
  <div>
    <dialogos-app :dialogos="dialogos" :personaje="false"></dialogos-app>
    <v-layout class="wrap-md-and-down" align-center="">
      <v-flex class="flex-img">
        <img src="../../assets/Modulo 3/Felicitaciones.png" alt="Felicitaciones">
      </v-flex>
    </v-layout>
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Modulo 3/AUDIO 22',
    ]"></audio-player> 
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogos: [
        "Has llegado al final del ABC de las reservas y los recursos de hidrocarburos ¡felicitaciones!, puedes cerrar esta ventana." 
      ],
      preguntas: []
    }
  },
  created() {
    this.$store.commit('nextShow', false)
    this.preguntas = require('../../assets/Modulo 1/diapositiva-14.json');
  }
}
</script>
<style lang="scss" scoped>
@import '../../sass/helpers/moduleButtons';
</style>
